module.exports = __webpack_public_path__ + "static/media/toronto.3c573d34.jpg";